// components/Composite/Spreadsheet/Spreadsheet.js
import React from 'react';
import PropTypes from 'prop-types';

const isEmptyRow = (row) => {
  if (!Array.isArray(row) || row.length === 0) return true;
  return row.every((cell) => cell === '' || cell == null);
};

const isFootnoteRow = (row) => {
  if (!Array.isArray(row) || row.length === 0) return false;
  return String(row[0]).trim().startsWith('#');
};

const cleanRows = (rows, headerCount) =>
  rows
    .filter((row) => !isEmptyRow(row) && !isFootnoteRow(row))
    .map((row) => {
      if (row.length >= headerCount) return row;
      return [...row, ...Array(headerCount - row.length).fill('')];
    });

const Spreadsheet = ({ value = {} }) => {
  const { caption, headers = [], rows = [] } = value;

  const cleaned = cleanRows(rows, headers.length);

  if (!cleaned.length) return null;

  return (
    <section className="section section-full mt-lg">
      <div className="section__inner">

        {caption && (
          <div className="section__header">
            <div className="text-block-title">{caption}</div>
          </div>
        )}

        <div className="section__body">
          <div className="block">
            <div className="block__body">
              <div className="surface surface-outlined surface-pad-none overflow-x-auto">
                <table className="table">
                  {headers.length > 0 && (
                    <thead>
                      <tr>
                        {headers.map((header, i) => (
                          <th key={i}>{header}</th>
                        ))}
                      </tr>
                    </thead>
                  )}
                  <tbody>
                    {cleaned.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {row.map((cell, cellIndex) => (
                          <td key={cellIndex}>{cell}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

Spreadsheet.propTypes = {
  value: PropTypes.shape({
    caption: PropTypes.string,
    headers: PropTypes.arrayOf(PropTypes.string),
    rows: PropTypes.arrayOf(PropTypes.array),
  }),
};

export default Spreadsheet;